import "./order-card-header.scss";

import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { FunctionComponent } from "react";

import DateModal from "@client/components/date-modal/date-modal";
import { CircleCountdown } from "@client/components/reusable/circle-countdown";
import { getTotalNumberOfProducts } from "@client/components/reusable/hooks/useGetTotalNumberOfProducts";
import SvgIcon from "@client/components/reusable/SvgIcons";
import { ReactComponent as InfoIcon } from "@client/components/reusable/SvgIcons/library/info_icon.svg";
import { Order, OrderStatuses } from "@client/stores";

interface OrderCardHeaderProps {
	order: Order;
	closeOrderCardModal?: () => any;
	isCollapsedCard?: boolean;
	isDateModalVisible?: boolean;
	isOrderCardModal?: boolean;
	handleDateModalState?: (value: boolean) => void;
	isHistorySection?: boolean;
	isReadyTab?: boolean;
}

export const OrderCardHeader: FunctionComponent<OrderCardHeaderProps> =
	observer(
		({
			order,
			closeOrderCardModal,
			isCollapsedCard,
			isDateModalVisible,
			isOrderCardModal,
			handleDateModalState,
			isHistorySection,
			isReadyTab,
		}) => {
			function getTotalItemsText(items: number) {
				if (items > 1) {
					return "items";
				} else {
					return "item";
				}
			}

			const totalItems = getTotalNumberOfProducts(order);
			const isPartialPickup = order.products?.find(
				(product) => product.order_details?.qtyCanceled
			);
			const timebombsEnabled = process.env.REACT_APP_TIMEBOMBS_ENABLED == "1";

			function showDateModal(e: React.MouseEvent<Element, MouseEvent>) {
				e.preventDefault();
				e.stopPropagation();
				handleDateModalState(true);
			}

			function getOrderId() {
				return `#${order.order_meta.magentoSaleId || order.id}`;
			}

			function closeDateModal(e) {
				e.preventDefault();
				e.stopPropagation();
				handleDateModalState(false);
			}

			return (
				<div
					className={classNames("card-header", {
						["isDateModalOpened"]: isDateModalVisible,
					})}
				>
					{isDateModalVisible && (
						<DateModal
							orderDate={
								order.order_meta.createdAt || order.dates.received.received_at
							}
							orderId={`# ${order.order_meta.magentoSaleId || order.id}`}
							closeModal={(e) => closeDateModal(e)}
						/>
					)}
					<div className="card-header-left" onClick={(e) => showDateModal(e)}>
						<div className="order-id">
							{getOrderId()}
							{!isOrderCardModal && !isHistorySection && !isReadyTab && (
								<SvgIcon component={InfoIcon} />
							)}
						</div>
						<div className="user-name">
							{`${
								order.shipping_details.user_details.firstName
							} ${order.shipping_details.user_details.lastName?.charAt(0)}.`}
						</div>
					</div>
					<div className="card-header-right">
						<div className="total-items">
							{totalItems} {getTotalItemsText(totalItems)}
						</div>

						{isPartialPickup && !isCollapsedCard && (
							<div className="partial-pickup-tag">Partial Pick-up</div>
						)}

						{timebombsEnabled &&
							(order.status === OrderStatuses.Pending ||
								order.status === OrderStatuses.Picking) && (
								<CircleCountdown
									key={order.id}
									order={order}
									closeOrderCardModal={closeOrderCardModal}
								/>
							)}
					</div>
				</div>
			);
		}
	);
